import { render, staticRenderFns } from "./LinkPopup.vue?vue&type=template&id=bde19560&"
import script from "./LinkPopup.vue?vue&type=script&lang=js&"
export * from "./LinkPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports